import { EarningsItem } from '@api/api/earnings';
import { EarningsInsightType } from '@api/api/earnings-insights';
import { dedupeArray } from '@helpers/utils/arrays/arrays';
import { useMemo } from 'react';

import { useThemeEarningsInsights } from './useThemeEarningsInsights';
import { useThemeEarningsThemes } from './useThemeEarningsThemes';
import { getTopEarningsDrivers } from './utils';

const RECAP_INSIGHT_TYPES: EarningsInsightType[] = ['recap'];

export const useThemeEarningsDrivers = (reportedEarnings: EarningsItem[]) => {
  const {
    earningsInsightByEarningsId,
    isEarningsInsightsFetching,
    isKgFilterLoading,
  } = useThemeEarningsInsights({
    earningsIds: reportedEarnings.map(earning => earning.id),
    entityTags: dedupeArray(
      reportedEarnings.map(earning => earning.entity_tag)
    ),
    insightTypes: RECAP_INSIGHT_TYPES,
  });
  const { themesByEarningsId, isFetching: isThemesFetching } =
    useThemeEarningsThemes(
      earningsInsightByEarningsId,
      'recap',
      !isKgFilterLoading
    );

  const drivers = useMemo(
    () => getTopEarningsDrivers(themesByEarningsId),
    [themesByEarningsId]
  );

  return {
    drivers,
    isFetching: isEarningsInsightsFetching || isThemesFetching,
  };
};
